// extracted by mini-css-extract-plugin
module.exports = {"article":"GridArticleCollection_article__OPlms"};